(() => {
  class ProductDetail extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.els();
      this.settings();
      this.listeners();
    }

    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      this.variantChangeUnsubscriber = window.subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.sectionId !== this.sectionId) return;
        this.currentVariant = event.currentVariant;
        this.onVariantChange();
      });
    }

    disconnectedCallback() {
      const unsubscribers = [
        this.swatchUnsubscriber,
        this.uomChangeUnsubscriber,
        this.variantChangeUnsubscriber,
      ];

      unsubscribers.forEach(unsubscriber => unsubscriber && unsubscriber());
    }

    els() {
      this.addToCartEl = this.querySelector('[data-product-add-to-cart]');
      this.addToCartPriceEl = this.querySelector('[data-product-add-to-cart-price]');
      this.addonInputEls = this.querySelectorAll('[data-product-addon-inputs]');
      this.bundleInputEl = this.querySelector('[data-product-bundle-prop]');
      this.bundledWithInputEl = this.querySelector('[data-product-bundled-with]');
      this.headerEl = document.querySelector('.shopify-section--header');
      this.infoEl = this.querySelector(`#ProductInfo-${this.sectionId}`);
      this.klarna = this.querySelector('[data-product-klarna]');
      this.mediaEl = this.querySelector('.pdp__media');
      this.pageSectionEls = this.closest('main')?.querySelectorAll('.shopify-section');
      this.sectionEl = this.closest('.shopify-section');
    }

    settings() {
      this.idsToUpdate = ['pdpBadge', 'pdpGallery', 'pdpTitle', 'price', 'variantRadios', 'productForm', 'pdpAddons', 'pdpSecondary'];
      this.sectionIds = [];
      this.pageSectionEls && this.pageSectionEls.forEach(section => this.sectionIds.push(section.id.split('shopify-section-')[1]));
      this.shouldUpdateUrl = this.dataset.hasCustomProduct !== 'true';
    }

    listeners() {
      subscribe(PUB_SUB_EVENTS.swatchChange, event => {
        if (event.source !== 'product-detail') return;
        this.onChange(event.url);
      });

      const onHistoryChange = () => {
        const updateActiveSwatch = true;
        this.updateContent(location.href, updateActiveSwatch);
      };

      window.addEventListener('popstate', onHistoryChange);

      this.stickyMedia();

      document.addEventListener('resizeEnded', () => {
        this.stickyMedia();
      });
    }

    addonSelectedIndex(id, selectedData) {
      return selectedData.findIndex(item => item.id === id);
    }

    onChange(url) {
      this.updateContent(url);
    }

    onVariantChange() {
    }

    stickyMedia() {
      if (!this.mediaEl) return;
      if (window.matchMedia('(max-width: 1023px)').matches) return;
      const isSticky = this.mediaEl.offsetHeight + this.headerEl.offsetHeight - 40 <= window.innerHeight;
      this.mediaEl.classList[isSticky ? 'add' : 'remove']('pdp__media--sticky');
    }

    updateActiveSwatch(url) {
      const activeSwatchEl = this.infoEl.querySelector(`.product-swatches__item--active`);
      if (activeSwatchEl) activeSwatchEl.classList.remove('product-swatches__item--active');
      const newActiveSwatchEl = this.infoEl.querySelector(`[data-swatch-item][href="${url}"]`);
      newActiveSwatchEl && newActiveSwatchEl.classList.add('product-swatches__item--active');
    }

    updateContent(url, updateActiveSwatch = false) {
      fetch(`${url}?section_id=${this.sectionId}`)
        .then(response => response.text())
        .then(responseText => {
          this.updateDetails(responseText);
          this.updateUrl(url);
          if (updateActiveSwatch) this.updateActiveSwatch(url);
        })
        .catch((e) => {
          console.error(e);
        });
    }

    updateDetails(html) {
      this.idsToUpdate.forEach(id => {
        const elId = `${id}-${this.sectionId}`;
        const el = this.querySelector(`#${elId}`);
        const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
        const parsedEl = parsedHtml.querySelector(`#${elId}`);
        if (!(el && parsedEl)) return;

        el.innerHTML = parsedEl.innerHTML;
      })

      requestAnimationFrame(() => {
        window.swipers();
        window.inView();
      });
    }

    updateUrl(url) {
      if (!this.shouldUpdateUrl) return;
      window.history.pushState({}, '', url)
    }
  }

  if (!customElements.get('product-detail')) {
    customElements.define('product-detail', ProductDetail);
  }
})();
